<template>
  <div class="purchase">
    <el-form ref="sizeForm" :rules="rules" :model="sizeForm">
      <div class="wrap">
        <div class="main">
          <div class="main_left">
            <header class="main__header">
              <div class="follow-steps">
                <p>1</p>
              </div>
              <h2 class="section__title">{{ $t('deliveryTime') }}</h2>
              <div class="timeslots">
                <div v-for="(times,index) in timeSlots" :key="index">
                  <el-radio
                    style="border: 0; width: 100%; height: 1em;"
                    :disabled="times.available==false"
                    v-model="deliveryTime"
                    :label="times.value"
                  >
                    <span>{{ times.name }}</span>
                  </el-radio>
                </div>
              </div>
            </header>
            <main class="main__content">
              <div class="step__sections">
                <div class="section section--shipping-address">
                  <div class="addAddress">
                    <div class="section__header__purchase">
                      
                      <div class="follow-steps">
                        <p>2</p>
                      </div>
                      <h2 class="section__title" style="marginBottom: 10px">{{ $t('deliveryInfo') }}</h2>
                      <div class="delivery_info__warning">
                        <span>{{ $t('deliveryInfoWarning') }}</span>
                      </div>
                      <div
                        v-if="!this.checkoutWithinRadius && addressChoice"
                        class="time_tip__purchase"
                      >
                        <span class="error-message">{{ $t('notInArea') }}</span>
                      </div>
                      <div v-if="!addressChoice" class="time_tip">
                        <span>{{ $t('selectAddress') }}</span>
                      </div>
                    </div>
                    <div
                      style="marginBottom: 1em"
                      class="address-container"
                      v-if="addresses.length > 0"
                    >
                      <div style="margin: 0.2em" v-for="(address,index) in addresses" :key="index">
                        <el-radio
                          @change="validateDeliveryRadiusCheckout($event)"
                          v-model="addressChoice"
                          :label="address"
                        >
                          <div class="next-line">
                            <span>{{address.Street + ', ' + address.City + ', ' + address.State + ' ' + address.Zip}}</span>
                          </div>
                        </el-radio>
                      </div>
                    </div>
                    <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                      <div class="title" :class="isAddAddress?'':'bg_none'" @click="addAddress">
                        <i :class="isAddAddress?'el-icon-minus':'el-icon-plus'"></i>
                        <span>{{ $t('addNewAddress') }}</span>
                      </div>
                      <div class="fieldset" v-show="isAddAddress">
                        <div class="field">
                          <!--地址信息-->
                          <div class="two">
                            <div :class="firstName?'firstName':''" class="width">
                              <el-form-item v-bind:label="$t('firstName')" prop="firstName">
                                <el-input
                                  v-bind:placeholder="$t('firstName')"
                                  v-model="sizeForm.firstName"
                                  @keyup.native="contact"
                                ></el-input>
                              </el-form-item>
                            </div>
                            <div :class="lastName?'lastName':''" class="width">
                              <el-form-item v-bind:label="$t('lastName')" prop="lastName">
                                <el-input
                                  v-bind:placeholder="$t('lastName')"
                                  v-model="sizeForm.lastName"
                                  @keyup.native="contact"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                          <div class="address">
                            <div class="width" :class="phone?'phone':''">
                              <el-form-item v-bind:label="$t('phone')" prop="phone">
                                <el-input
                                  v-bind:placeholder="$t('mobilePhone')"
                                  v-model="sizeForm.phone"
                                  @keyup.native="contact"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                          <div :class="address?'address':''">
                            <el-form-item v-bind:label="$t('address')" prop="address">
                              <el-input
                                v-bind:placeholder="$t('addressIncludingApt')"
                                v-model="sizeForm.address"
                                @keyup.native="contact"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div :class="city?'city':''">
                            <el-form-item v-bind:label="$t('city')" prop="city">
                              <el-input
                                v-bind:placeholder="$t('city')"
                                v-model="sizeForm.city"
                                @keyup.native="contact"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="three">
                            <div class="width_30">
                              <div class="city">
                                <el-form-item v-bind:label="$t('country')" prop="Country">
                                  <el-select v-model="sizeForm.Country" value>
                                    <el-option
                                      v-for="item in CountryList"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    ></el-option>
                                  </el-select>
                                </el-form-item>
                              </div>
                            </div>
                            <div class="width_30">
                              <div class="city">
                                <el-form-item v-bind:label="$t('state')" prop="State">
                                  <el-select
                                    v-model="sizeForm.State"
                                    v-bind:placeholder="$t('pleaseSelect')"
                                    value
                                  >
                                    <el-option
                                      v-for="item in stateOptions"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value"
                                    ></el-option>
                                  </el-select>
                                </el-form-item>
                              </div>
                            </div>
                            <div class="width_30">
                              <div :class="code?'code':''">
                                <el-form-item v-bind:label="$t('zipCode')" prop="code">
                                  <el-input
                                    v-bind:placeholder="$t('zipCode')"
                                    v-model="sizeForm.code"
                                    @keyup.native="contact"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </div>
                          </div>
                          <button
                            class="place btn"
                            @click="postNewAddress(sizeForm, $event)"
                          >{{ $t('saveAddress') }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="addPayment">
                    <div class="follow-steps">
                      <p>3</p>
                    </div>
                    <h2 class="section__title">{{ $t('choosePaymentMethod') }}</h2>
                    <div
                      v-show="((!this.checkoutWithinRadius && addressChoice) || !addressChoice) && showPaymentError"
                      class="time_tip__purchase"
                    >
                      <span class="error-message">{{ $t('chooseValidAddressPay') }}</span>
                    </div>
                    <div class="payment-container" v-bind:style="{marginBottom: 10 + 'px'}">
                      <div
                        v-if="(!this.checkoutWithinRadius && addressChoice) || !addressChoice"
                        @click="showPaymentError=true"
                      >
                        <el-radio
                          class="radio-purchase"
                          :disabled="(!this.checkoutWithinRadius && addressChoice) || !addressChoice"
                          v-model="paymentMethod"
                          v-bind:label="$t('alipay')"
                        >
                          <span>
                            <i class="fab fa-alipay fa-2x" style="color: #C0C4CC;"></i>
                          </span>
                        </el-radio>
                        <el-radio
                          class="radio-purchase"
                          :disabled="(!this.checkoutWithinRadius && addressChoice) || !addressChoice"
                          v-model="paymentMethod"
                          v-bind:label="$t('wechatpay')"
                        >
                          <span>
                            <i class="fab fa-weixin fa-2x" style="color: #C0C4CC;"></i>
                          </span>
                        </el-radio>
                        <el-radio
                          class="radio-purchase"
                          :disabled="(!this.checkoutWithinRadius && addressChoice) || !addressChoice"
                          v-model="paymentMethod"
                          v-bind:label="$t('creditcard')"
                        >
                          <span>
                            <i class="far fa-credit-card fa-2x" style="color: #C0C4CC;"></i>
                          </span>
                        </el-radio>
                      </div>
                      <div v-else>
                        <el-radio class="radio-purchase" v-model="paymentMethod" label="creditcard">
                          <span>
                            <i class="far fa-credit-card fa-2x"></i>
                          </span>
                        </el-radio>
                        <el-radio class="radio-purchase" v-model="paymentMethod" label="alipay">
                          <span>
                            <i class="fab fa-alipay fa-2x"></i>
                          </span>
                        </el-radio>
                        <el-radio class="radio-purchase" v-model="paymentMethod" label="wechatpay">
                          <span>
                            <i class="fab fa-weixin fa-2x"></i>
                          </span>
                        </el-radio>
                      </div>
                    </div>
                    <!-- </header> -->
                    <div
                      v-if="paymentMethod === 'creditcard' && !this.cardLoading && !this.cardSuccess"
                      class="section__content"
                    >
                      <div
                        class="title"
                        :class="isAddPayment?'':'bg_none'"
                        @click="isAddPayment = !isAddPayment"
                      >
                        <i :class="isAddPayment?'el-icon-minus':'el-icon-plus'"></i>
                        <span>{{ $t('addPayment') }}</span>
                      </div>
                      <div class="fieldset" v-show="isAddPayment">
                        <div class="field">
                          <!--地址信息-->
                          <div>
                            <el-form-item
                              v-bind:label="$t('cardHolderName')"
                              prop="card_holder_name"
                            >
                              <el-input
                                v-bind:placeholder="$t('cardHolderName2')"
                                v-model="sizeForm.card_holder_name"
                                @keyup.native="contact"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div>
                            <el-form-item v-bind:label="$t('creditCardNumber')" prop="Card">
                              <el-input
                                v-bind:placeholder="$t('creditCardNumber2')"
                                v-model="sizeForm.Card"
                                @keyup.native="contact"
                                @input="cardNumberFormatter(sizeForm.Card)"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="two">
                            <div class="width">
                              <el-form-item v-bind:label="$t('cardExpiration')" prop="Expiration">
                                <el-input
                                  v-bind:placeholder="$t('cardExpiration2')"
                                  v-model="sizeForm.Expiration"
                                  @keyup.native="contact"
                                  @input="cardExpireDateFormatter(sizeForm.Expiration)"
                                  :maxlength="5"
                                ></el-input>
                              </el-form-item>
                            </div>
                            <div class="width">
                              <el-form-item v-bind:label="$t('cvc')" prop="CVC">
                                <el-input
                                  v-bind:placeholder="$t('cvc2')"
                                  v-model="sizeForm.CVC"
                                  :maxlength="4"
                                  @keyup.native="contact"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </div>
                          <!--单选开始-->
                          <span v-show="cardError" style="color:red">{{cardError}}</span>
                          <el-button
                            @click="fetchCardToken()"
                            class="place btn"
                          >{{ $t('submitCardInfo') }}</el-button>
                          <!--end单选结束-->
                          <!--end地址信息-->
                        </div>
                      </div>
                    </div>
                    <div v-else-if="this.cardLoading" class="svg">
                      <svg
                        version="1.1"
                        id="loader-1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="120px"
                        height="120px"
                        viewBox="0 0 50 50"
                        style="enable-background:new 0 0 50 50;"
                        xml:space="preserve"
                      >
                        <path
                          fill="#ff6f37"
                          d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                        >
                          <animateTransform
                            attributeType="xml"
                            attributeName="transform"
                            type="rotate"
                            from="0 25 25"
                            to="360 25 25"
                            dur="1s"
                            repeatCount="indefinite"
                          />
                        </path>
                      </svg>
                    </div>
                    <div v-else-if="!this.cardLoading && this.cardSuccess">
                      <h3>{{ $t('cardSubmitSuccess') }}</h3>
                    </div>
                  </div>
                  <span v-show="cardError" style="color:red">{{cardError}}</span>
                </div>
              </div>
            </main>
            <footer class="main__footer" v-if="this.necessaryCartItems.AvailableCredit !== 0">
              <h2 class="section__title">{{ $t('userCredit') }}</h2>
              <div style="marginTop: 20px; marginBottom: 20px">
                <el-checkbox
                  v-model="IsCreditUsed"
                  :disabled="!addressChoice || !this.checkoutWithinRadius"
                ></el-checkbox>
                <span style="marginLeft: 10px; fontSize: 17px">
                  {{ $t('use_my_credit_balance') }}
                  <span
                    style="color: red"
                  >(${{this.necessaryCartItems.AvailableCredit}})</span>
                </span>
              </div>
            </footer>
            <footer v-if="!this.promoCodeLoading" class="main__footer">
              <div class="follow-steps">
                <p>4</p>
              </div>
              <h2 class="section__title">{{ $t('discount') }}</h2>
              <div class="discount" :class="promoCode ? 'discountCode' : ''">
                <el-form-item v-bind:label="$t('discountCode')">
                  <el-input
                    v-bind:placeholder="$t('discountCode')"
                    v-model="promoCode"
                    @keyup.native="contact"
                  ></el-input>
                  <span class="apply" @click="validatePromotionCode($event)">
                    <i class="el-icon-right"></i>
                  </span>
                </el-form-item>
              </div>
              <span style="color:red;" v-show="this.promoCodeValid">{{ this.promoCodeValid}}</span>
              <span
                style="color:red;"
                v-show="this.promoCodeSuccessful && !this.promoCodeLoading && !this.promoCodeValid"
              >{{ $t('promoApplied') }}</span>
            </footer>
            <div v-else-if="this.promoCodeLoading && !this.promoCodeSuccessful" class="svg">
              <svg
                version="1.1"
                id="loader-1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                x="0px"
                y="0px"
                width="120px"
                height="120px"
                viewBox="0 0 50 50"
                style="enable-background:new 0 0 50 50;"
                xml:space="preserve"
              >
                <path
                  fill="#ff6f37"
                  d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                >
                  <animateTransform
                    attributeType="xml"
                    attributeName="transform"
                    type="rotate"
                    from="0 25 25"
                    to="360 25 25"
                    dur="1s"
                    repeatCount="indefinite"
                  />
                </path>
              </svg>
            </div>
          </div>

          <div class="complementary">
            <div class="complementary-inside">
              <div class="follow-steps">
                <p>5</p>
              </div>
            <h2 class="section__title">{{ $t('orderSummary') }}</h2>
            <div class="sidebar">
              <div class="sidebar__content">
                <div class="orderList">
                  <ul>
                    <li
                      v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines"
                      :key="index"
                    >
                      <div class="img">
                        <img :src="item.Thumbnail" alt />
                        <span class="orderNum">{{item.Quantity}}</span>
                      </div>
                      <div class="min">
                        <span v-if="$i18n.locale=='en'">{{item.Name}}</span>
                        <span v-if="$i18n.locale=='ch'">{{item.Description}}</span>
                         <div>
                          <button :disabled="addDisabled || item.Quantity < 2" @click="decreaseAddToCart(item, $event)" class="decrement">-</button>
                          <i :disabled="addDisabled" @click="confirmDeleteItem = true; currentDeleteItem = item;" class="fa fa-trash-o decrement-trash"  aria-hidden="true"></i>
                          <button :disabled="addDisabled" @click="throttleAddToCart(item, $event)" class="increment">+</button>
                        </div>
                      </div>

                      <div class="price">${{item.TotalPrice.toFixed(2)}}</div>
                    </li>
                  </ul>
                  <div class="comput">
                    <div class="lilist">
                      <div class="left">{{ $t('subtotal') }}</div>
                      <div v-if="this.TotalPrice" class="right">${{this.TotalPrice.toFixed(2)}}</div>
                    </div>

                    <div class="lilist">
                      <div class="left">{{ $t('promotion') }}</div>
                      <div class="right">-${{this.Savings.toFixed(2)}}</div>
                    </div>

                    <div class="lilist">
                      <div class="left">{{ $t('tax') }}</div>
                      <div class="right">${{this.necessaryCartItems.Tax}}</div>
                    </div>

                    <div class="lilist">
                      <div class="left">{{ $t('shipping') }}</div>
                      <div class="right">${{this.$store.state.cart.necessaryCartItems.Delivery}}</div>
                    </div>

                     <!-- <div v-if="this.IsShareCreditUsed" class="lilist">
                      <div class="left">{{ $t('sharingDiscount') }}</div>
                      <div v-if="this.$store.state.cart.necessaryCartItems.ShareCreditAmount" class="right">-${{this.$store.state.cart.necessaryCartItems.ShareCreditAmount.toFixed(2)}}</div>
                    </div> -->
                  </div>

                  <div class="Tol">
                    <div v-if="this.IsShareCreditUsed" class="left">{{ $t('total') }}</div>
                    <div v-if="!this.IsShareCreditUsed" class="left"></div>
                    <div class="right">
                      <span class="new-red" v-if="!this.IsShareCreditUsed">{{ $t('total') }}</span>
                      <span class="new-red" v-if="this.IsShareCreditUsed">{{ $t('originalTotal') }}</span>
                      <!-- <span>USD</span> -->
                      <span v-if="!this.IsShareCreditUsed" style="marginLeft: 20px" class="new-red">${{this.GrandTotal}}</span>
                      <span v-if="this.IsShareCreditUsed && this.GrandTotal && this.$store.state.cart.necessaryCartItems.ShareCreditAmount" style="marginLeft: 20px" class="new-red">${{(Number(this.GrandTotal) + this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}}</span>
                    </div>
                  </div>

                  <div class="err" v-if="this.orderFailed">
                    <span class="error-message">Error: {{this.orderFailMessage}}</span>
                  </div>
                </div>
                
                <!-- <div class="sharePay">
                  <p class="shareExplain" v-if="this.$store.state.cart.necessaryCartItems.ShareCreditAmount">{{ $t('shareExplain1') }}<span style="color: rgb(127, 226, 80)">${{(this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}}</span>{{ $t('shareExplain2') }}</p>
                  <p class="shareSaved" v-if="this.$store.state.cart.necessaryCartItems.ShareCreditAmount">{{ $t('savingsPrice') }}${{(this.GrandTotal-(this.IsShareCreditUsed ? 0 : this.$store.state.cart.necessaryCartItems.ShareCreditAmount)).toFixed(2)}}</p>
                  <div class="pay">
                    <el-button
                      v-if="!this.IsShareCreditUsed && this.GrandTotal && this.$store.state.cart.necessaryCartItems.ShareCreditAmount"
                      :disabled="false"
                      @click="shareModalOpen = true"
                      class="place btn">
                      {{ $t('shareForDiscount') }} (${{(this.GrandTotal-this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}})
                    </el-button>
                    <p class="sharingThank" v-if="this.IsShareCreditUsed">{{ $t('sharingThank') }}</p>
                  </div>
                </div>
                <div class="normalPay">
                  <div class="pay">
                    <el-button
                      :disabled="!isFormValidForSubmission()"
                      @click="onSubmit('sizeForm')"
                      class="place btn"
                    >{{ $t('payForOrder') }}（${{this.GrandTotal}})</el-button>
                  </div>
               </div> -->

                <div v-if="!this.IsShareCreditUsed" class="sharePay2">
                  <div v-if="!this.IsShareCreditUsed && this.GrandTotal && this.$store.state.cart.necessaryCartItems.ShareCreditAmount" style="marginTop: 10px">
                    <span class="sh1">{{ $t('shareToCircle') }}</span>
                    <span v-if="this.$store.state.cart.necessaryCartItems.ShareCreditPercentage" class="sh2">{{this.$store.state.cart.necessaryCartItems.ShareCreditPercentage*100}}%</span>
                    <span v-if="$i18n.locale=='en'" class="sh3e">{{ $t('priceAfterShare') }}&nbsp;&nbsp;${{(Number(this.GrandTotal)-this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}}</span>
                    <span v-if="$i18n.locale=='ch'" class="sh3c">{{ $t('priceAfterShare') }}&nbsp;&nbsp;${{(Number(this.GrandTotal)-this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}}</span>
                  </div>
                  <span class="sh5">{{ $t('goShare') }}</span>
                  <div class="sh6">
                    <span class="sh5m">{{ $t('goShare') }}</span>
                    <img @click="onClickShareWechat" class="wechat-icon-container" src="../assets/img/wechat_icon.png">
                    <ShareNetwork
                      v-for="network in networks"
                      :network="network.network"
                      :key="network.network"
                      :url="sharing.url"
                      :title="sharing.title"
                      :description="sharing.description"
                      :quote="sharing.quote"
                      :hashtags="sharing.hashtags"
                      :twitterUser="sharing.twitterUser"
                      @open="sharingClosed"
                    >
                      <img class="icon" :src="network.icon" alt />
                    </ShareNetwork>
                  </div>
                </div>
                <div v-if="this.IsShareCreditUsed" class="sharePay3 orderList">
                  <div class="Tol">
                    <div v-if="this.IsShareCreditUsed" class="left">{{ $t('sharingDiscount') }}</div>
                    <div class="left"></div>
                    <div class="right">
                      <span v-if="this.$store.state.cart.necessaryCartItems.ShareCreditAmount" style="marginLeft: 20px" class="new-red">-${{this.$store.state.cart.necessaryCartItems.ShareCreditAmount.toFixed(2)}}</span>
                    </div>
                  </div>
                  <div class="sh7">
                    <span>{{ $t('whatYouPay') }}</span>
                    <span class="sh8">${{this.GrandTotal}}</span>
                  </div>
                </div>
                 <div class="normalPay">
                  <div v-if="!this.IsShareCreditUsed" class="pay">
                    <el-button
                      :disabled="!isFormValidForSubmission()"
                      @click="onSubmit('sizeForm')"
                      class="skip-place btn"
                    >
                    {{ $t('skipShare') }}
                    </el-button>
                  </div>
                  <div v-if="this.IsShareCreditUsed" class="pay">
                    <el-button
                      :disabled="!isFormValidForSubmission()"
                      @click="onSubmit('sizeForm')"
                      class="noskip-place btn"
                    >
                    {{ $t('checkOut') }}
                    </el-button>
                  </div>
               </div>

              </div>
            </div>
            </div>
          </div>

          <transition name="modal" v-if="shareModalOpen">
            <div class="modal-mask" @click="shareModalOpen = false">
              <div class="modal-wrapper">
                <div class="modal-container2">
                  <div>
                    <img @click="onClickShareWechat" class="wechat-icon-container" src="../assets/img/wechat_icon.png">
                    <ShareNetwork
                      v-for="network in networks"
                      :network="network.network"
                      :key="network.network"
                      :url="sharing.url"
                      :title="sharing.title"
                      :description="sharing.description"
                      :quote="sharing.quote"
                      :hashtags="sharing.hashtags"
                      :twitterUser="sharing.twitterUser"
                      @open="sharingClosed"
                    >
                      <img class="icon" :src="network.icon" alt />
                    </ShareNetwork>
                  </div>
                </div>
              </div>
            </div>
          </transition>

        <el-dialog
          :title="$t('wechat_share')"
          :visible.sync="wechatModalOpen"
          class="myWechatDia"
        >
          <share :config="config"></share>    
        </el-dialog>

        </div>
      </div>
      <!--提示框-->
      <div class="refundContent">
        <el-dialog
          title="Refund policy"
          :visible.sync="this.refund"
          width="90%"
          :before-close="refundShow"
        >
          <p>Refund Policy</p>
          <p>
            A refund, or credit, for the cost of unopened merchandise, less a 15% restocking fee, will be issued when
            merchandise is returned within 10 days of receipt. Shipping cost will only be refunded if the return is due to
            an error made by MerryHomeFashion.
          </p>
          <p>
            Please note: MerryHomeFashion is not responsible for items opened or damaged due to high pressure/altitude.
            These items will not be refunded or accepted for return.
          </p>
          <p>Out of Stock Items</p>
          <p>
            Due to MerryHomeFashion's large variety of items and constant volume of sales, occasionally, items listed for
            sale on the e-store may be out of stock. MerryHomeFashion will issue an immediate refund for items ordered but
            currently not in stock.
          </p>
        </el-dialog>
      </div>
      <div class="privacyContent">
        <el-dialog title="Privacy policy" :visible.sync="this.privacy" width="90%">
          <p>Privacy Notice</p>
          <p>
            This privacy notice discloses the privacy practices for MerryHomeFashion. This privacy notice applies solely
            to information collected by this web site. It will notify you of the following:
          </p>
          <p>
            What personally identifiable information is collected from you through the web site, how it is used and with
            whom it may be shared.
          </p>
          <p>What choices are available to you regarding the use of your data.</p>
          <p>
            The security procedures in place to protect the misuse of your information. How you can correct any
            inaccuracies in the information.
          </p>
          <p>Information Collection, Use, and Sharing</p>
          <p>
            We are the sole owners of the information collected on this site. We only have access to/collect information
            that you voluntarily give us via email or other direct contact from you. We will not sell or rent this
            information to anyone.
          </p>
          <p>
            We will use your information to respond to you, regarding the reason you contacted us. We will not share your
            information with any third party outside of our organization, other than as necessary to fulfill your request,
            e.g. to ship an order.
          </p>
          <p>
            Unless you ask us not to, we may contact you via email in the future to tell you about specials, new products
            or services, or changes to this privacy policy.
          </p>
          <p>Your Access to and Control Over Information</p>
          <p>
            You may opt out of any future contacts from us at any time. You can do the following at any time by
            contacting us via the email address or phone number given on our website:
          </p>
          <p>See what data we have about you, if any.</p>
          <p>Change/correct any data we have about you.</p>
          <p>Have us delete any data we have about you.</p>
          <p>Express any concern you have about our use of your data.</p>
          <p>Security</p>
          <p>
            We take precautions to protect your information. When you submit sensitive information via the website, your
            information is protected both online and offline.
          </p>
          <p>
            Wherever we collect sensitive information (such as credit card data), that information is encrypted and
            transmitted to us in a secure way. You can verify this by looking for a closed lock icon at the bottom of your
            web browser, or looking for "https" at the beginning of the address of the web page.
          </p>
          <p>
            While we use encryption to protect sensitive information transmitted online, we also protect your information
            offline. Only employees who need the information to perform a specific job (for example, billing or customer
            service) are granted access to personally identifiable information. The computers/servers in which we store
            personally identifiable information are kept in a secure environment.
          </p>
          <p>
            If you feel that we are not abiding by this privacy policy, you should contact us immediately via telephone
            at (555) 555-5555 or via email.
          </p>
        </el-dialog>
      </div>
      <!--end提示框-->
    </el-form>

    <transition name="modal" v-if="detectedGroupItemModal">
      <div class="modal-mask" @click="detectedGroupItemModal = false">
        <div class="modal-wrapper">
          <div class="modal-container3" @click.stop>
              <div class="infoctn">
              <p class="info" style="color: #F5A623">{{ $t('groupFollowingItem') }}</p>
            </div>
              <div class="infoctn">
              <p v-if="$i18n.locale=='en'" class="info">{{ detectedGroupItem.Name }}</p>
              <p v-if="$i18n.locale=='ch'" class="info">{{ detectedGroupItem.Description }}</p>
            </div>
            <div class="infoctn">
              <p class="info" style="color: #F5A623">{{ $t('groupPleaseRemove') }}</p>
            </div>
            <div class="btnctn">
              <button @click="detectedGroupItemModal = false" class="btn" >{{ $t('close') }}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modal" v-if="confirmDeleteItem">
      <div class="modal-mask" @click="confirmDeleteItem = false">
        <div class="modal-wrapper">
          <div class="modal-container9" @click.stop>
              <div class="infoctn">
              <p class="info">{{ $t('cofirmDeleteWarning') }}</p>
            </div>
            <div class="infoctn">
              <p v-if="$i18n.locale=='en'" class="info-gray">{{ currentDeleteItem.Name }}</p>
              <p v-if="$i18n.locale=='ch'" class="info-gray">{{ currentDeleteItem.Description }}</p>
            </div>
            <div class="btnctn">
              <button style="marginRight: 5px" @click="confirmDeleteItem = false" class="btn" >{{ $t('cancel') }}</button>
              <button style="marginLeft: 5px" @click="deleteItem(currentDeleteItem)" class="btn" >{{ $t('confirm') }}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { validateZipCode, validatePhoneNumber } from "../../config/validation";
import Vue from "vue";
import moment from "moment";
import addresses from "../store/modules/addresses";
import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);
import Share from 'vue-social-share'
Vue.use(Share)

import {
  isUserAuthenticated,
} from "../store/modules/cart";

import fbicon from "../assets/img/facebook_icon.png";
import twittericon from "../assets/img/twitter_icon.png";
import pinteresticon from "../assets/img/pinterest_icon.png";
import whatsappicon from "../assets/img/whatsapp_icon.png";
import lineicon from "../assets/img/line_icon.png";
import wechaticon from "../assets/img/wechat_icon.png";

export default {
  name: "purchase",
  data() {
    return {
      addDisabled: false,
      confirmDeleteItem: false,
      currentDeleteItem: null,

      wechatTimeout: null,
      scrollPosition: null,
      accordionOpen: "accordion",
      labelPosition: "top",
      address: "",
      promoCode: "",
      card_holder_name: "",
      addressChoice: "",
      order: false,
      radio: "", // 单选框默认
      deliveryTime: "",
      creditCardSuccess: false,
      formLabelAlign: {
        name: "",
        password: "",
      },
      showPaymentError: false,
      paymentMethod: "creditcard",
      activeNames: ["1"],
      Subtotal: 15,
      total: 15,
      // 表单默认数据
      sizeForm: {
        name: "",
        subscribe: true, //是否订阅
        firstName: "", //名字
        lastName: "", //名字
        address: "", //地址
        apartment: "", //地址
        city: "", //城市
        code: "", //编码
        phone: "", //联系方式
        Country: "United States", //国家/地区
        State: "CA", //地区
        gateCode: "", //送货上门详细地址
        whether: 1, //是否确认
        confirmAddress: "", //确认地址
        Card: "", //卡号
        Expiration: "", //到期时间
        CVC: "", //安全码
        storage: true, //是否保存信息
        card_holder_name: "",
      },
      cardData: {
        cardNumber: null,
        expiry: null,
        cvc: null,
        // cardType: null,
        CardName: null,
        salesOrderId: null,
      },
      rules: {
        firstName: [
          {
            required: true,
            message: "First Name is Required",
            trigger: "blur",
          },
          {
            min: 2,
            max: 20,
            message: "first name length at least 3",
            trigger: "blur",
          },
        ],
        lastName: [
          { required: true, message: "Last Name is Required", trigger: "blur" },
          {
            min: 2,
            max: 20,
            message: "last name length at least 3",
            trigger: "blur",
          },
        ],
        address: [
          { required: true, message: "Address is required", trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "address length at least 3",
            trigger: "blur",
          },
        ],
        city: [
          { required: true, message: "City is Required", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "city length at least 3",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "Zip Code is Required", trigger: "blur" },
          {
            min: 3,
            max: 5,
            message: "code length at least 3",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            message: "Phone Number is Required",
            trigger: "blur",
          },
          {
            min: 3,
            max: 12,
            message: "phone length at least 3",
            trigger: "blur",
          },
        ],
        Country: [
          { required: true, message: "Country is Required", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "Country length at least 3",
            trigger: "blur",
          },
        ],
        Card: [
          { required: true, message: "Card Info is Required", trigger: "blur" },
          {
            min: 16,
            max: 23,
            message: "Card number should be 13 - 19 digits",
            trigger: "blur",
          },
        ],
        Expiration: [
          {
            required: true,
            message: "Expiration Date is Required",
            trigger: "blur",
          },
          {
            min: 5,
            max: 5,
            message: "Expiration data shoud be in format MM/YY",
            trigger: "blur",
          },
        ],
        CVC: [
          {
            required: true,
            message: "Security Code is Required",
            trigger: "blur",
          },
          { min: 3, max: 4, message: "CVC length at least 3", trigger: "blur" },
        ],
      },
      //下拉框默认数据
      stateOptions: this.$store.state.addresses.states, // States drop down data
      CountryList: [
        {
          value: "",
          label: "---",
        },
        {
          value: "United States",
          label: "United States",
        },
      ],

      // input label
      input_label: false,
      firstName: false,
      lastName: false,
      addressName: "",
      apartment: false,
      city: false,
      code: false,
      phone: false,
      privacy: false,
      refund: false,
      // end input label

      //商品列表默认数据
      isAddAddress: false, //展示添加地址
      isAddPayment: true, //展示添加支付方式

      //user credit
      IsCreditUsed: false,

      //sharing
      sharing: {
        url: "https://www.morningplaza.com",
        title: "This is the Title.",
        description: "This is the Description.",
        quote: "This is the Quote.",
        hashtags: "MerryHomeFashion,hashtag,test",
        twitterUser: "",
      },
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: fbicon,
        },
        // {
        //   network: "facebook",
        //   name: "Facebook",
        //   icon: wechaticon,
        // },
        {
          network: "twitter",
          name: "Twitter",
          icon: twittericon,
        },
        {
          network: "pinterest",
          name: "Pinterest",
          icon: pinteresticon,
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: whatsappicon,
        },
        {
          network: "line",
          name: "Line",
          icon: lineicon,
        },
      ],
      config: {
        url: 'https://www.morningplaza.com',
        title: 'MerryHomeFashion',
        description: 'MerryHomeFashion',
        sites: ['wechat'],
        wechatQrcodeTitle: "",
        wechatQrcodeHelper: "",
      },
      shareModalOpen: false,
      wechatModalOpen: false,
      detectedGroupItem: {},
      detectedGroupItemInv: {},
      detectedGroupItemModal: false,
    };
  },
  methods: {
    ...mapActions("addresses", ["fetchMLMNetwork"]),
    ...mapActions('products',["fetchGroupBuyWithId"]),
    ...mapMutations("products", ["updateActiveProduct"]),
    ...mapMutations("checkout", [
      "setPricesForCheckout",
      "saveTotalPrice",
      "saveGrandTotal",
      "clearPromoCode",
      "clearCard",
      "updatePromoCode",
      "updateIsShareCreditUsed",
    ]),
    ...mapActions('cart',['addProductToCart']),
    onClickShareWechat() {
      this.shareModalOpen = false;
      this.wechatModalOpen = true;
      // console.log("wechat");
    },
    sharingClosed() {
      localStorage.setItem('shareCreditUsed', true);
      this.updateIsShareCreditUsed(true);
    },
    cardNumberFormatter(value) {
      var v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
      var matches = v.match(/\d{4,19}/g);
      var match = (matches && matches[0]) || "";
      var parts = [];

      for (var i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
      }
      if (parts.length) {
        this.sizeForm.Card = parts.join(" ");
      } else {
        this.sizeForm.Card = value;
      }
    },
    cardExpireDateFormatter(date) {
      if (date.length == 3) {
        if (date[date.length - 1] !== "/") {
          var temp = this.sizeForm.Expiration.split("");
          temp.splice(2, 0, "/");
          this.sizeForm.Expiration = temp.join("");
          return;
        } else {
          this.sizeForm.Expiration = this.sizeForm.Expiration.slice(0, 2);
        }
      }
    },

    contact(el) {
      this.sizeForm.name !== ""
        ? (this.input_label = true)
        : (this.input_label = false);
      this.sizeForm.firstName !== ""
        ? (this.firstName = true)
        : (this.firstName = false);
      this.sizeForm.lastName !== ""
        ? (this.lastName = true)
        : (this.lastName = false);
      this.sizeForm.address !== ""
        ? (this.address = true)
        : (this.address = false);
      // this.sizeForm.apartment !== '' ? this.apartment = true : this.apartment = false;
      this.sizeForm.city !== "" ? (this.city = true) : (this.city = false);
      this.sizeForm.code !== "" ? (this.code = true) : (this.code = false);
      this.sizeForm.phone !== "" ? (this.phone = true) : (this.phone = false);
      // this.sizeForm.discountCode !== '' ? this.discountCode = true : this.discountCode = false
    },
    updateScroll() {
      this.scrollPosition = this.$refs.infoBox.clientHeight - window.scrollY;
    },
    refundShow() {
      this.refund = !this.refund;
    },
    validatePromotionCode(e) {
      e.preventDefault();
      this.$store
        .dispatch("checkout/validatePromoCode", [
          this.promoCode,
          this.TotalPrice,
        ])
        .then(() => {
          let cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
          cartItems.PromoCode = this.PromoCode;
          cartItems.IsCreditUsed = this.IsCreditUsed;
          cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
          this.$store.dispatch("cart/saveAndAdjustCart", cartItems);
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        });
    },
    // paymentMethod: "",
    // savings: 0,
    // GrandTotal: 0,
    // Subtotal: 0,
    // activeNames: ['1'],
    // Subtotal:15,
    // total:15,
    // sizeForm: {
    //   name: "",
    //   subscribe: true,
    //   firstName: '',
    //   lastName: '',
    //   address: '',
    //   apartment: '',
    //   city: '',
    //   code: '',
    //   phone: '',
    //   Country: '',
    //   State: '',
    //   gateCode: '',
    //   whether: 1,
    //   confirmAddress: '',
    //   Card: '',
    //   Expiration: '',
    //   CVC: '',
    //   storage: true,
    // },
    // cardData: {
    //   cardNumber: null,
    //   expiry: null,
    //   cvc: null,
    //   CardName: null,
    //   salesOrderId: null,
    // },
    checkForm: async function (form) {
      this.errors = [];
      if (!form.Street) {
        this.errors.push(this.$t("addressRequired"));
      }
      if (!form.City) {
        this.errors.push(this.$t("cityRequired"));
      }
      if (!form.Country) {
        this.errors.push(this.$t("countryRequired"));
      }
      if (!form.State) {
        this.errors.push(this.$t("stateRequired"));
      }
      if (validateZipCode(form.Zip)) this.errors.push(this.$t("zipCodeWrong"));
      if (validatePhoneNumber(form.Telephone))
        this.errors.push(this.$t("phoneNumberWrong"));
    },
    postNewAddress(form, event) {
      event.preventDefault();
      const address = {};
      address.Street = form.address;
      address.City = form.city;
      address.State = form.State;
      address.Zip = form.code;
      address.Country = form.Country;
      address.gateCode = form.gateCode;
      address.FirstName = form.firstName;
      address.LastName = form.lastName;
      address.Telephone = form.phone;
      this.checkForm(address);
      if (!this.errors.length) {
        this.$store.dispatch("addresses/postAddress", address).then(() => {
          this.$store.dispatch("addresses/fetchAddresses");
          this.isAddAddress = false;
        });
      } else {
        alert(this.errors);
      }
    },
    // not doing anything
    whetherNum(num) {
      console.log(num);
    },
    onSubmit(sizeForm) {
      // localStorage.setItem('shareCreditUsed', false); // for testing
      // return; // for testing
      let orderData = {};
      let time = moment()._d;
      orderData.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      orderData.FinalPrice = this.TotalPrice;
      orderData.TotalPrice = this.necessaryCartItems.GrandTotal;
      orderData.GrandTotal = this.necessaryCartItems.GrandTotal;
      orderData.SalesOrder_id = this.salesOrderId;
      orderData.TimeSlot = time;
      orderData.card_reference = this.card_reference; // undefined?
      orderData.PaymentMethod = this.paymentMethod;
      orderData.Billing_CustomerDetail_id = this.addressChoice.CustomerDetail_id;
      orderData.terminal = this.device;
      orderData.DispatchDate = this.deliveryTime;
      orderData.Deliver_CustomerDetail_id = this.addressChoice.CustomerDetail_id;
      orderData.PromoCode = this.PromoCode || this.necessaryCartItems.PromoCode;
      orderData.Savings = this.Savings;
      orderData.IsShareCreditUsed = this.IsShareCreditUsed;
      orderData.IsGroupBuy = 0;
      orderData.GroupBuyId = null;
      for (const key in this.necessaryCartItems) {
        if (!orderData.hasOwnProperty(key)) {
          orderData[key] = this.necessaryCartItems[key];
        }
      }

      let groupItemError = false;
      this.fetchGroupBuyWithId()
      .then(res => {
        res.data.record.map(r => {
          orderData.Sales_Order_Lines.map(j => {
            if (r.ProductNum === j.ProductNum) {
              groupItemError = true;
              this.detectedGroupItem = j;
              this.detectedGroupItemInv = r;
            }
          })
        });
        if (groupItemError === true && orderData.Sales_Order_Lines.length > 1) {
          this.detectedGroupItemModal = true;
        } else if (groupItemError === true && orderData.Sales_Order_Lines.length === 1) {
          orderData.IsGroupBuy = 1;
          orderData.GroupBuyId = this.detectedGroupItemInv.id;
          this.$store.dispatch("checkout/submitOrder", orderData);
        } else {
          orderData.IsGroupBuy = 0;
          orderData.GroupBuyId = null;
          this.$store.dispatch("checkout/submitOrder", orderData);
        }
      })
      .catch(err => {
        console.log('err', err)
      })

    },
    fetchCardToken() {
      let paymentData = {};
      paymentData.cardNum = this.sizeForm.Card.split(" ").join("");
      paymentData.expDate =
        "20" + this.sizeForm.Expiration.split("/").reverse().join("-");
      paymentData.cvv = this.sizeForm.CVC;
      paymentData.salesOrderId = this.salesOrderId;
      paymentData.card_holder_name = this.sizeForm.card_holder_name;
      // this.$store.dispatch('checkout/fetchACCardToken', paymentData)
      this.$store.dispatch("checkout/saveCreditCard", paymentData);
    },
    // this function not doing anything
    submitOrder(paymentData) {
      paymentData.card_reference = this.card_reference;
      this.$store.dispatch("checkout/submitOrder", paymentData);
    },
    validateAddress() {
      this.$store.dispatch("navbar/validateDeliveryRadius");
    },
    validateDeliveryRadiusCheckout(event) {
      this.$store.dispatch(
        "navbar/validateDeliveryRadius",
        this.addressChoice.Zip
      );
    },
    addAddress(priorAddress) {
      if (this.isAddAddress === true) {
        this.isAddAddress = false;
      } else {
        this.isAddAddress = true;
      }
    },
    isFormValidForSubmission() {
      let valid = false;
      if (this.paymentMethod === "creditcard") {
        if (this.cardSuccess) {
          valid = true;
        } else {
          valid = false;
        }
      } else if (
        this.paymentMethod === "wechatpay" ||
        this.paymentMethod === "alipay"
      ) {
        valid = true;
      }
      if (this.addressChoice === "") {
        valid = false;
      }
      if (this.orderLoading || this.cardLoading || this.windowOpening) {
        valid = false;
      }
      if (this.$store.state.cart.cartProductsList.Sales_Order_Lines) {
        if (!this.$store.state.cart.cartProductsList.Sales_Order_Lines.length) {
          valid = false;
        }
      }
      if (this.paymentMethod === "") {
        valid = false;
      }
      if (!this.checkoutWithinRadius) {
        valid = false;
      }
      if (this.deliveryTime === "") {
        valid = false;
      }
      return valid;
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({
        name: "productDetails",
        query: { productNum: product.ProductNum },
      });
    },

    getItemQuantity: function() {
      if (isUserAuthenticated() && this.cartProductsList && this.cartProductsList.Sales_Order_Lines) {
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.num = this.cartProductsList.Sales_Order_Lines[i].Quantity;
            this.found = true;
          } 
        }
      } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.num = this.cartProductsList[i].quantity;
            this.found = true;
          }
        }
      }
    },
    deleteItem(item) {
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/deleteCartItem', item.Product_id)
        .then(() => {
          this.confirmDeleteItem = false;
          this.$store.dispatch('cart/getCart');
        });
      }
    },
    decreaseAddToCart: function(item, e) {
      e.preventDefault();
      this.addDisabled = true;
      setTimeout(() => {
        this.addDisabled = false;
      }, 1000);
      let quantity = item.Quantity - 1;
      if (quantity < 1) {
        // this.deleteItem(item);
      } else {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          item.quantity = quantity;
          this.$store.dispatch('cart/updateLocalCart', item)
          .then(() => {
            this.$store.dispatch('cart/fetchCartProducts')
          });
        }
      }
    },
    throttleAddToCart:  _.debounce(function(item, event) {
      this.addDisabled = true;
      setTimeout(() => this.addDisabled = false, 1000);
      this.addThisToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function(item) {
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})   
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item, event])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      // flyToElement(payload.event.target, $('.cart-link')); 
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail(product) {
      alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
    },

  },
  mounted() {
    if (localStorage.getItem('shareCreditUsed') && (localStorage.getItem('shareCreditUsed') === true || localStorage.getItem('shareCreditUsed') === 'true')) {
      this.updateIsShareCreditUsed(true);
    }
    if (this.userDetails) {
      this.fetchMLMNetwork(this.userDetails.mobile_user_id);
    }
    // window.addEventListener('scroll', this.updateScroll);
  },
  beforeMount() {
    this.$store.dispatch("cart/getCart").then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
      this.$store.dispatch("cart/saveAndAdjustCart", cartItems).then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      });
    });
    this.$store.dispatch("checkout/fetchTimeSlots");
    this.$store.dispatch("addresses/fetchAddresses");
  },
  watch: {
    timeSlots: function (newVal, oldVal) {
        this.timeSlots.map(t => {
          if (t.available === true) {
            this.deliveryTime = t.value;
            return;
          }
        });
    },
    wechatModalOpen: function (newVal, oldVal) {
      let that = this;
      if (newVal === true) {
        this.wechatTimeout = setTimeout(function() {
          localStorage.setItem('shareCreditUsed', true);
          that.updateIsShareCreditUsed(true);
        }, 5000);
      }
      if (newVal === false && this.wechatTimeout) {
        clearTimeout(this.wechatTimeout);
      }
    },
    IsCreditUsed: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        let cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.IsCreditUsed = this.IsCreditUsed;
        cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
        this.$store.dispatch("cart/saveAndAdjustCart", cartItems).then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        });
      }
    },
     IsShareCreditUsed: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        let cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.IsCreditUsed = this.IsCreditUsed;
        cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
        this.$store.dispatch("cart/saveAndAdjustCart", cartItems).then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        });
      }
    },
    isAddAddress: function (newVal, oldVal) {
      immediate: true;
      if (newVal === true && oldVal === false) {
        this.addressChoice = "";
      }
    },
    addresses: function (newVal, oldVal) {
      if (newVal !== oldVal || newVal.length !== oldVal.length) {
        // this.addresses.map((address) => {
        //   if (address.IsDefault) {
        //     this.addressChoice = address;
        //     this.addressName = address.FirstName + " " + address.LastName;
        //   }
        // });
        let addressIndex = this.addresses.length - 1;
        if (addressIndex >= 0 ) {
          this.addressChoice = this.addresses[addressIndex];
          this.addressName = this.addresses[addressIndex].FirstName + " " + this.addresses[addressIndex].LastName;
        }
      }
    },
    addressChoice: function (newVal, oldVal) {
      // reset the error message for payment
      this.showPaymentError = false;

      if (newVal !== oldVal) {
        this.addresses.map((address) => {
          if (
            address.CustomerDetail_id === this.addressChoice.CustomerDetail_id
          ) {
            this.addressName = address.FirstName + " " + address.LastName;
          }
        });
      }
      if (oldVal === "" && newVal !== oldVal) {
        this.isAddAddress = false;
      }
    },
    cardLoading: function (newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.isAddPayment = false;
      }
    },
    promoCodeSuccessful: function (newVal, oldVal) {
      if (newVal === true) {
        let value = (
          this.TotalPrice -
          this.Savings.toFixed(2) +
          this.necessaryCartItems.Tax +
          this.necessaryCartItems.Delivery
        ).toFixed(2);
        this.saveGrandTotal(Number(value));
      }
    },
    necessaryCartItems: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updatePromoCode(this.necessaryCartItems.Savings);
      }
    },
    cartProductsList: {
      deep: true,
      handler(newVal) {
        if (newVal && this.$route.name === "purchase") {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
          cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
          this.$store.dispatch("cart/saveAndAdjustCart", cartItems).then(() => {
            this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          });
          this.clearPromoCode();
          this.IsCreditUsed = false;
          this.clearCard();
        }
      },
    },
    networkData: function (newVal, oldVal) {
      if (newVal && newVal[0]) {
        this.config['url'] = "https://www.morningplaza.com/register/" + newVal[0].id;
        this.sharing['url'] = "https://www.morningplaza.com/register/" + newVal[0].id;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("cart/getCart").then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
      this.$store.dispatch("cart/saveAndAdjustCart", cartItems).then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      });
    });
    this.clearPromoCode();
    this.IsCreditUsed = false;
    this.clearCard();
    next();
  },
  computed: mapState({
    salesOrderId: (state) => state.cart.cartProductsList.SalesOrder_id,
    card_reference: (state) => state.checkout.card_reference,
    timeSlots: (state) => state.checkout.timeSlots,
    addresses: (state) => state.addresses.customerDetails,
    customerDetails: (state) => state.profile.customerDetails,
    necessaryCartItems: (state) => state.cart.necessaryCartItems,
    cartProductsList: (state) => state.cart.cartProductsList,
    device: (state) => state.navbar.device,
    orderLoading: (state) => state.checkout.orderLoading,
    orderSuccessful: (state) => state.checkout.orderSuccessful,
    cardLoading: (state) => state.checkout.cardLoading,
    cardSuccess: (state) => state.checkout.cardSuccess,
    cardError: (state) => state.checkout.cardError,
    checkoutWithinRadius: (state) => state.navbar.checkoutWithinRadius,
    promoCodeLoading: (state) => state.checkout.promoCodeLoading,
    promoCodeSuccessful: (state) => state.checkout.promoCodeSuccessful,
    promoCodeError: (state) => state.checkout.promoCodeError,
    promoCodeValid: (state) => state.checkout.promoCodeValid,
    PromoCode: (state) => state.checkout.PromoCode,
    Savings: (state) => state.checkout.Savings,
    GrandTotal: (state) => state.checkout.GrandTotal,
    TotalPrice: (state) => state.checkout.TotalPrice,
    Tax: (state) => state.checkout.Tax,
    cartClicked: (state) => state.cart.cartClicked,
    itemCount: (state) => state.cart.itemCount,
    windowOpening: (state) => state.checkout.windowOpening,
    orderFailed: (state) => state.checkout.orderFailed,
    orderFailMessage: (state) => state.checkout.orderFailMessage,
    IsShareCreditUsed: (state) => state.checkout.IsShareCreditUsed,
    userDetails: (state) => state.auth.userDetails,
    networkData: (state) => state.addresses.networkData,
  }),
};
</script>

<style lang="less">
// @import 'vue-social-share/dist/client.css';
@import "../assets/css/purchase.less";
@import "../assets/css/animation.less";
@import "../assets/css/modal.less";
</style>



// WEBPACK FOOTER //
// src/view/purchase.vue